import {
  LineDeviceDetails,
  LogicalDevice,
  LogicalDeviceDetailsTypes,
  MacDeviceDetails,
  RoamingDeviceDetails,
} from "@sportal/api";
import { DiscoveredActionTypes } from "./discovered";
import { RequestsWithNameActionTypes } from "./requestsWithName";
import { LineActionTypes } from "./lines";
import { InfectedDevicesActionTypes } from "./infectedDevices";
import { LogicalDevicesActionTypes } from "./logicalDevices";

// region payloads

export interface SBLogicalDevice extends Omit<LogicalDevice, "deviceDetails"> {
  logicalDeviceId: string;
}

interface SBBaseDeviceDetails {
  logicalDeviceId: string;
}

export interface SBRoamingDeviceDetails
  extends RoamingDeviceDetails,
    SBBaseDeviceDetails {}

export interface SBLineDeviceDetails
  extends LineDeviceDetails,
    SBBaseDeviceDetails {}

export interface SBMacDeviceDetails
  extends MacDeviceDetails,
    SBBaseDeviceDetails {}

export type SBDeviceDetails =
  | SBRoamingDeviceDetails
  | SBLineDeviceDetails
  | SBMacDeviceDetails;

export const isRoamingType = (
  details: SBDeviceDetails
): details is SBRoamingDeviceDetails =>
  details.type === LogicalDeviceDetailsTypes.Roaming;

export interface SBLogicalDeviceWithDetails extends SBLogicalDevice {
  details: Record<string, SBDeviceDetails>;
}

// endregion

export type DevicesActionTypes =
  | DiscoveredActionTypes
  | RequestsWithNameActionTypes
  | LineActionTypes
  | InfectedDevicesActionTypes
  | LogicalDevicesActionTypes;
